import React from 'react';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentBoxEditor, {
  CommentBoxEditorProps,
} from '../../../../lego/CommentBoxEditor';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';

interface Props extends CommentBoxEditorProps {}

const EditorView: React.FC<Props> = ({ ...rest }) => (
  <CommentBoxLayout
    avatar={<CommentBoxAvatar />}
    content={<CommentBoxEditor {...rest} />}
  />
);
EditorView.displayName = 'EditorView';

export default EditorView;
